export default "__VITE_ASSET__B2jtOfYB__"